
// import DatePicker from "react-datepicker";
// import React, { useState } from 'react';
// import { useRef } from "react";
// import '../styles/MyProfile.css';

// const MyProfile = ({ userData, setUserData, isEditing, setIsEditing }) => {
//   const [showImageModal, setShowImageModal] = useState(false);

//   const [passwords, setPasswords] = useState({
//     current: '',
//     new: '',
//     confirm: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUserData(prev => ({ ...prev, [name]: value }));
//   };

//   const handlePasswordChange = (e) => {
//     setPasswords({ ...passwords, [e.target.name]: e.target.value });
//   };

//   // --- SAVE PROFILE DATA TO DATABASE ---
//   const handleSave = async () => {
//     console.log("Saving for user:", userData);

//     const payload = {
//       id: userData.id,
//       EmpId: userData.EmpId,
//       Phonenumber: userData.phone,
//       Gender: userData.gender,
//       Dob: userData.dob,
//       City: userData.city,
//       Address: userData.address,
//       LocalAddress: userData.local_address,
//       Country: userData.country,
//       ProfilePicture: userData.profileImage
//     };

//     if (!payload.id) {
//       alert("Error: No primary ID found. Please re-login.");
//       return;
//     }

//     try {
//       const response = await fetch("/gt-api/update_profile.php", {
//         method: "POST",
//          credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("SUCCESS: Profile saved!");
//         setIsEditing(false);
//       } else {
//         alert("SERVER ERROR: " + result.message);
//       }
//     } catch (error) {
//       alert("Connection error. Check if XAMPP Apache is running.");
//     }
//   };

//   // --- PASSWORD UPDATE FUNCTION ---
//   const handlePasswordUpdate = async () => {
//     if (!passwords.current || !passwords.new || !passwords.confirm) {
//       alert("Please fill all password fields");
//       return;
//     }
//     if (passwords.new !== passwords.confirm) {
//       alert("New passwords do not match!");
//       return;
//     }

//     try {
//       const response = await fetch("/gt-api/update_password.php", {
//         method: "POST",
//          credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           empid: userData.id,
//           current: passwords.current,
//           new: passwords.new
//         }),
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("SUCCESS: Security credentials updated.");
//         setPasswords({ current: '', new: '', confirm: '' });
//       } else {
//         alert("ERROR: " + result.message);
//       }
//     } catch (error) {
//       console.error("Password Update Error:", error);
//       alert("System error. Check connection.");
//     }
//   };


// const dobRef = useRef(null);


//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 1024 * 1024) {
//         alert("Image too large. Please select a file under 1MB.");
//         return;
//       }
//       const reader = new FileReader();
//       reader.onloadend = async () => {
//         const base64Image = reader.result;
//         setUserData(prev => ({ ...prev, profileImage: base64Image }));
//         await saveProfileImage(base64Image);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeProfilePicture = async () => {
//     if (window.confirm("Are you sure you want to remove your profile photo?")) {
//       setUserData(prev => ({ ...prev, profileImage: null }));
//       await saveProfileImage(null);
//     }
//   };

//   const saveProfileImage = async (imgData) => {
//     const payload = {
//       id: userData.id,
//       ProfilePicture: imgData
//     };

//     try {
//       const response = await fetch("/gt-api/update_profile.php", {
//         method: "POST",
//          credentials: "include",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const result = await response.json();
//       if (!result.success) {
//         console.error("Failed to sync image to database:", result.message);
//       }
//     } catch (error) {
//       console.error("Network error during image sync:", error);
//     }
//   };



//  return (
//     <div className="profile-container animate-fade">
//       <div className="profile-card-glass">

//         {/* BIG EDIT BUTTON ON TOP RIGHT */}
//         {!isEditing && (
//           <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px 20px 0 0' }}>
//             <button
//               className="btn-edit"
//               onClick={() => setIsEditing(true)}
//               style={{
//                 padding: '12px 35px',
//                 fontSize: '0.95rem',
//                 fontWeight: '600',
//                 letterSpacing: '1px',
//                 minWidth: '160px'
//               }}
//             >
//               EDIT PROFILE
//             </button>
//           </div>
//         )}

//         <div className="profile-header">
//           <div className="avatar-section">
//             <img
//               src={userData.profileImage || `https://ui-avatars.com/api/?name=${userData.firstName}+${userData.lastName}&background=3b82f6&color=fff&bold=true&rounded=true&size=320`}
//               alt="User Profile"
//               className="profile-avatar"
//               onClick={() => setShowImageModal(true)}
//               style={{ cursor: "pointer" }}
//             />
//             <div className="avatar-actions">
//               <label className="image-edit-badge" title="Upload New Photo" style={{ display: isEditing ? 'flex' : 'none' }}>
//                 <span>📷</span>
//                 <input type="file" accept="image/*" onChange={handleImageChange} hidden />
//               </label>
//               {userData.profileImage && isEditing && (
//                 <button className="image-remove-badge" onClick={removeProfilePicture} title="Remove Photo">
//                   <span>🗑️</span>
//                 </button>
//               )}
//             </div>
//           </div>

//           <div className="user-intro">
//             <h2 style={{
//               display: 'flex',
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: '4px',
//               margin: '0'
//             }}>
//               <span>{userData.FirstName} {userData.LastName}</span>
//               <span style={{ color: 'rgba(255,255,255,0.3)', fontWeight: '300' }}>|</span>
//               <span style={{
//                 color: '#e3e9e9',
//                 fontSize: '1rem',
//                 fontWeight: '500',
//                 letterSpacing: '1px',
//                 textTransform: 'uppercase'
//               }}>
//                 {userData.Designation || "Software Development Engineer"}
//               </span>
//             </h2>

//             <span className="badge-id" style={{ marginTop: '8px', display: 'block' }}>
//               Employee ID: {userData.EmpId}
//             </span>
//           </div>
//         </div>

//         <div className="profile-details-grid">
//           <div className="input-box">
//             <label>First Name</label>
//             <input value={userData.firstName} disabled className="locked-input" />
//           </div>
//           <div className="input-box">
//             <label>Last Name</label>
//             <input value={userData.lastName} disabled className="locked-input" />
//           </div>
//           <div className="input-box">
//             <label>Email Address</label>
//             <input value={userData.email} disabled className="locked-input" />
//           </div>
//           <div className="input-box">
//             <label>Department</label>
//             <input value={userData.Department || ""} disabled className="locked-input" />
//           </div>

//           <div className="input-box">
//             <label>Mobile Number</label>
//             <input name="phone" value={userData.phone || ""} onChange={handleInputChange} disabled={!isEditing} />
//           </div>
//           <div className="input-box">
//             <label>Gender</label>
//             <span style={{ display: 'none' }}>Select Gender</span>
//             <select name="gender" value={userData.gender || ""} onChange={handleInputChange} disabled={!isEditing}>
//               <option value="">Select Gender</option>
//               <option value="Male">Male</option>
//               <option value="Female">Female</option>
//               <option value="Other">Other</option>
//             </select>
//           </div>

//           <div className="input-box custom-date-container">
//             <label style={{ color: '#00ffff', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '11px' }}>
//               Date of Birth
//             </label>

//             <div className="date-input-wrapper">
//               <input
//                 ref={dobRef}
//                 type="date"
//                 name="dob"
//                 className="sophisticated-input"
//                 value={userData.dob || ""}
//                 onChange={handleInputChange}
//                 disabled={!isEditing}
//                 min="1920-01-01"
//                 max={new Date().toISOString().split("T")[0]}
//               />

//               <span
//                 className="calendar-glow-icon"
//                 onClick={() => {
//                   if (!isEditing) return;

//                   if (dobRef.current?.showPicker) {
//                     dobRef.current.showPicker();
//                   } else {
//                     dobRef.current.focus();
//                   }
//                 }}
//               >
//                 📅
//               </span>
//             </div>
//           </div>

//           <div className="input-box">
//             <label>City</label>
//             <input name="city" value={userData.city || ""} onChange={handleInputChange} disabled={!isEditing} />
//           </div>
//           <div className="input-box" style={{ gridColumn: "span 2" }}>
//             <label>Permanent Address</label>
//             <input name="address" value={userData.address || ""} onChange={handleInputChange} disabled={!isEditing} />
//           </div>

//           <div className="input-box">
//             <label>Current / Local Address</label>
//             <input name="local_address" value={userData.local_address || ""} onChange={handleInputChange} disabled={!isEditing} />
//           </div>
//           <div className="input-box">
//             <label>Country</label>
//             <input name="country" value={userData.country || ""} onChange={handleInputChange} disabled={!isEditing} />
//           </div>

//           <div className="password-separator" style={{ gridColumn: "span 2", margin: "30px 0 10px 0", borderBottom: "1px solid rgba(16, 185, 129, 0.2)", paddingBottom: "5px", color: "#10b981", fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "2px" }}>
//             🔐 Security Update Protocol
//           </div>

//           <div className="input-box" style={{ gridColumn: "span 2" }}>
//             <label>Current Password</label>
//             <input type="password" name="current" placeholder="••••••••" value={passwords.current} onChange={handlePasswordChange} disabled={!isEditing} />
//           </div>
//           <div className="input-box">
//             <label>New Password</label>
//             <input type="password" name="new" placeholder="Enter new password" value={passwords.new} onChange={handlePasswordChange} disabled={!isEditing} />
//           </div>
//           <div className="input-box">
//             <label>Confirm Password</label>
//             <input type="password" name="confirm" placeholder="Repeat new password" value={passwords.confirm} onChange={handlePasswordChange} disabled={!isEditing} />
//           </div>

//           <div className="input-box" style={{ gridColumn: "span 2" }}>
//             <button
//               type="button"
//               className="btn-update-pass"
//               onClick={handlePasswordUpdate}
//               disabled={!isEditing}
//               style={{
//                 width: '100%',
//                 maxWidth: '220px',
//                 height: '42px',
//                 background: isEditing ? 'rgba(16, 185, 129, 0.1)' : 'rgba(255,255,255,0.05)',
//                 border: isEditing ? '1px solid #10b981' : '1px solid #444',
//                 color: isEditing ? '#10b981' : '#666',
//                 cursor: isEditing ? 'pointer' : 'not-allowed',
//                 fontFamily: 'inherit',
//                 textTransform: 'uppercase',
//                 fontWeight: '600',
//                 borderRadius: '6px',
//                 transition: 'all 0.3s ease'
//               }}
//             >
//               Apply New Password
//             </button>
//           </div>
//         </div>

//         <div className="profile-footer">
//           {isEditing && (
//             <>
//               <button className="btn-save" onClick={handleSave}>Save Changes</button>
//               <button
//                 className="btn-pass"
//                 style={{ border: '1px solid #ef4444', color: '#ef4444' }}
//                 onClick={() => {
//                   setIsEditing(false);
//                   setPasswords({ current: '', new: '', confirm: '' });
//                 }}
//               >
//                 Cancel Edit
//               </button>
//             </>
//           )}
//         </div>
//       </div>
//       {showImageModal && (
//         <div
//           className="image-modal-overlay"
//           onClick={() => setShowImageModal(false)}
//         >
//           <div
//             className="image-modal-content-pc"
//             onClick={(e) => e.stopPropagation()} // prevent closing when clicking image
//           >
//             <img
//               src={userData.profileImage || `https://ui-avatars.com/api/?name=${userData.firstName}+${userData.lastName}`}
//               alt="Full Profile"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MyProfile;






























import DatePicker from "react-datepicker";
import React, { useState, useEffect, useMemo, useRef } from 'react';
import '../styles/MyProfile.css';

const MyProfile = ({ userData, setUserData, isEditing, setIsEditing, isManagementView = false }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [departmentsList, setDepartmentsList] = useState([]);

  const loggedUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch (e) {
      return {};
    }
  }, []);

  const isManagementUser = loggedUser?.role === "Management" || isManagementView;

  useEffect(() => {
    fetch("/gt-api/get_departments.php", {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.departments) {
          setDepartmentsList(data.departments);
        }
      })
      .catch(err => console.error("Fetch departments error:", err));
  }, []);

  const [passwords, setPasswords] = useState({
    current: '',
    new: '',
    confirm: ''
  });

  const renderFieldStatus = (val) => {
    const isFilled = val && String(val).trim() !== '' && String(val).trim() !== '0000-00-00';
    return (
      <span className={`field-status-badge ${isFilled ? 'filled' : 'empty'}`}>
        {isFilled ? '✓ Filled' : '⚠️ Empty'}
      </span>
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  // --- SAVE PROFILE DATA TO DATABASE ---
  const handleSave = async () => {
    console.log("Saving for user:", userData);

    const payload = {
      id: userData.id,
      EmpId: userData.EmpId,
      Phonenumber: userData.phone || userData.Phonenumber,
      Gender: userData.gender || userData.Gender,
      Dob: userData.dob || userData.Dob,
      City: userData.city || userData.City,
      Address: userData.address || userData.Address,
      LocalAddress: userData.local_address || userData.LocalAddress,
      Country: userData.country || userData.Country,
      Department: userData.Department || userData.DepartmentName,
      ProfilePicture: userData.profileImage
    };

    if (!payload.id) {
      alert("Error: No primary ID found. Please re-login.");
      return;
    }

    try {
      const response = await fetch("/gt-api/update_profile.php", {
        method: "POST",
         credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        alert("SUCCESS: Profile saved!");
        setIsEditing(false);
      } else {
        alert("SERVER ERROR: " + result.message);
      }
    } catch (error) {
      alert("Connection error. Check if XAMPP Apache is running.");
    }
  };

  // --- PASSWORD UPDATE FUNCTION ---
  const handlePasswordUpdate = async () => {
    if (!passwords.current || !passwords.new || !passwords.confirm) {
      alert("Please fill all password fields");
      return;
    }
    if (passwords.new !== passwords.confirm) {
      alert("New passwords do not match!");
      return;
    }

    try {
      const response = await fetch("/gt-api/update_password.php", {
        method: "POST",
         credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          empid: userData.id,
          current: passwords.current,
          new: passwords.new
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("SUCCESS: Security credentials updated.");
        setPasswords({ current: '', new: '', confirm: '' });
      } else {
        alert("ERROR: " + result.message);
      }
    } catch (error) {
      console.error("Password Update Error:", error);
      alert("System error. Check connection.");
    }
  };


const dobRef = useRef(null);


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1024 * 1024) {
        alert("Image too large. Please select a file under 1MB.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Image = reader.result;
        setUserData(prev => ({ ...prev, profileImage: base64Image }));
        await saveProfileImage(base64Image);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeProfilePicture = async () => {
    if (window.confirm("Are you sure you want to remove your profile photo?")) {
      setUserData(prev => ({ ...prev, profileImage: null }));
      await saveProfileImage(null);
    }
  };

  const saveProfileImage = async (imgData) => {
    const payload = {
      id: userData.id,
      ProfilePicture: imgData
    };

    try {
      const response = await fetch("/gt-api/update_profile.php", {
        method: "POST",
         credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!result.success) {
        console.error("Failed to sync image to database:", result.message);
      }
    } catch (error) {
      console.error("Network error during image sync:", error);
    }
  };



 return (
    <div className="profile-container animate-fade">
      <div className="profile-card-glass">

        {/* BIG EDIT BUTTON ON TOP RIGHT */}
        {!isEditing && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px 20px 0 0' }}>
            <button
              className="btn-edit"
              onClick={() => setIsEditing(true)}
              style={{
                padding: '12px 35px',
                fontSize: '0.95rem',
                fontWeight: '600',
                letterSpacing: '1px',
                minWidth: '160px'
              }}
            >
              EDIT PROFILE
            </button>
          </div>
        )}

        <div className="profile-header">
          <div className="avatar-section">
            <img
              src={userData.profileImage || `https://ui-avatars.com/api/?name=${userData.firstName}+${userData.lastName}&background=3b82f6&color=fff&bold=true&rounded=true&size=320`}
              alt="User Profile"
              className="profile-avatar"
              onClick={() => setShowImageModal(true)}
              style={{ cursor: "pointer" }}
            />
            <div className="avatar-actions">
              <label className="image-edit-badge" title="Upload New Photo" style={{ display: isEditing ? 'flex' : 'none' }}>
                <span>📷</span>
                <input type="file" accept="image/*" onChange={handleImageChange} hidden />
              </label>
              {userData.profileImage && isEditing && (
                <button className="image-remove-badge" onClick={removeProfilePicture} title="Remove Photo">
                  <span>🗑️</span>
                </button>
              )}
            </div>
          </div>

          <div className="user-intro">
            <h2 style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '4px',
              margin: '0'
            }}>
              <span>{userData.FirstName} {userData.LastName}</span>
              <span style={{ color: 'rgba(255,255,255,0.3)', fontWeight: '300' }}>|</span>
              <span style={{
                color: '#e3e9e9',
                fontSize: '1rem',
                fontWeight: '500',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>
                {userData.Designation || "Software Development Engineer"}
              </span>
            </h2>

            <span className="badge-id" style={{ marginTop: '8px', display: 'block' }}>
              Employee ID: {userData.EmpId}
            </span>
          </div>
        </div>

        <div className="profile-details-grid">
          <div className="input-box">
            <label>First Name</label>
            <input value={userData.firstName} disabled className="locked-input" />
          </div>
          <div className="input-box">
            <label>Last Name</label>
            <input value={userData.lastName} disabled className="locked-input" />
          </div>
          <div className="input-box">
            <label>Email Address</label>
            <input value={userData.email} disabled className="locked-input" />
          </div>
          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Department {renderFieldStatus(userData.Department || userData.DepartmentName)}
            </label>
            {isManagementUser ? (
              <select
                name="Department"
                value={userData.Department || userData.DepartmentName || ""}
                onChange={handleInputChange}
                disabled={!isEditing}
              >
                <option value="">Select Department</option>
                {departmentsList.map((dept, index) => (
                  <option key={dept.id || index} value={dept.DepartmentName || dept.department_name}>
                    {dept.DepartmentName || dept.department_name}
                  </option>
                ))}
              </select>
            ) : (
              <input value={userData.Department || userData.DepartmentName || ""} disabled className="locked-input" />
            )}
          </div>

          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Mobile Number {renderFieldStatus(userData.phone || userData.Phonenumber)}
            </label>
            <input name="phone" value={userData.phone || userData.Phonenumber || ""} onChange={handleInputChange} disabled={!isEditing} />
          </div>
          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Gender {renderFieldStatus(userData.gender || userData.Gender)}
            </label>
            <span style={{ display: 'none' }}>Select Gender</span>
            <select name="gender" value={userData.gender || userData.Gender || ""} onChange={handleInputChange} disabled={!isEditing}>
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="input-box custom-date-container">
            <label style={{ color: '#00ffff', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '11px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>Date of Birth</span>
              {renderFieldStatus(userData.dob || userData.Dob)}
            </label>

            <div className="date-input-wrapper">
              <input
                ref={dobRef}
                type="date"
                name="dob"
                className="sophisticated-input"
                value={userData.dob || userData.Dob || ""}
                onChange={handleInputChange}
                disabled={!isEditing}
                min="1920-01-01"
                max={new Date().toISOString().split("T")[0]}
              />

              <span
                className="calendar-glow-icon"
                onClick={() => {
                  if (!isEditing) return;

                  if (dobRef.current?.showPicker) {
                    dobRef.current.showPicker();
                  } else {
                    dobRef.current.focus();
                  }
                }}
              >
                📅
              </span>
            </div>
          </div>

          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              City {renderFieldStatus(userData.city || userData.City)}
            </label>
            <input name="city" value={userData.city || userData.City || ""} onChange={handleInputChange} disabled={!isEditing} />
          </div>
          <div className="input-box" style={{ gridColumn: "span 2" }}>
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Permanent Address {renderFieldStatus(userData.address || userData.Address)}
            </label>
            <input name="address" value={userData.address || userData.Address || ""} onChange={handleInputChange} disabled={!isEditing} />
          </div>

          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Current / Local Address {renderFieldStatus(userData.local_address || userData.LocalAddress)}
            </label>
            <input name="local_address" value={userData.local_address || userData.LocalAddress || ""} onChange={handleInputChange} disabled={!isEditing} />
          </div>
          <div className="input-box">
            <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              Country {renderFieldStatus(userData.country || userData.Country)}
            </label>
            <input name="country" value={userData.country || userData.Country || ""} onChange={handleInputChange} disabled={!isEditing} />
          </div>

          <div className="password-separator" style={{ gridColumn: "span 2", margin: "30px 0 10px 0", borderBottom: "1px solid rgba(16, 185, 129, 0.2)", paddingBottom: "5px", color: "#10b981", fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "2px" }}>
            🔐 Security Update Protocol
          </div>

          <div className="input-box" style={{ gridColumn: "span 2" }}>
            <label>Current Password</label>
            <input type="password" name="current" placeholder="••••••••" value={passwords.current} onChange={handlePasswordChange} disabled={!isEditing} />
          </div>
          <div className="input-box">
            <label>New Password</label>
            <input type="password" name="new" placeholder="Enter new password" value={passwords.new} onChange={handlePasswordChange} disabled={!isEditing} />
          </div>
          <div className="input-box">
            <label>Confirm Password</label>
            <input type="password" name="confirm" placeholder="Repeat new password" value={passwords.confirm} onChange={handlePasswordChange} disabled={!isEditing} />
          </div>

          <div className="input-box" style={{ gridColumn: "span 2" }}>
            <button
              type="button"
              className="btn-update-pass"
              onClick={handlePasswordUpdate}
              disabled={!isEditing}
              style={{
                width: '100%',
                maxWidth: '220px',
                height: '42px',
                background: isEditing ? 'rgba(16, 185, 129, 0.1)' : 'rgba(255,255,255,0.05)',
                border: isEditing ? '1px solid #10b981' : '1px solid #444',
                color: isEditing ? '#10b981' : '#666',
                cursor: isEditing ? 'pointer' : 'not-allowed',
                fontFamily: 'inherit',
                textTransform: 'uppercase',
                fontWeight: '600',
                borderRadius: '6px',
                transition: 'all 0.3s ease'
              }}
            >
              Apply New Password
            </button>
          </div>
        </div>

        <div className="profile-footer">
          {isEditing && (
            <>
              <button className="btn-save" onClick={handleSave}>Save Changes</button>
              <button
                className="btn-pass"
                style={{ border: '1px solid #ef4444', color: '#ef4444' }}
                onClick={() => {
                  setIsEditing(false);
                  setPasswords({ current: '', new: '', confirm: '' });
                }}
              >
                Cancel Edit
              </button>
            </>
          )}
        </div>
      </div>
      {showImageModal && (
        <div
          className="image-modal-overlay"
          onClick={() => setShowImageModal(false)}
        >
          <div
            className="image-modal-content-pc"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking image
          >
            <img
              src={userData.profileImage || `https://ui-avatars.com/api/?name=${userData.firstName}+${userData.lastName}`}
              alt="Full Profile"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MyProfile;